export default "data:image/svg+xml,sh-ac.svg"